import { Publish } from '@mui/icons-material';
import { Button } from '@mui/material';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class FileUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            height: '100px',
            showUpload: false,
            temporaryImage: null,
            width: '100px'
        };

        this.fileInput = React.createRef();
    }

    componentDidMount() {
        const { width, height } = this.props;
        if (width) {
            this.setState({ width });
        }
        if (height) {
            this.setState({ height });
        }
    }

    handleChange() {
        const { callbackFn } = this.props;

        if (this.fileInput.current.files[0]) {
            const reader = new FileReader();
            reader.onload = async (e) => {
                const payload = {
                    data: btoa(e.target.result),
                    type: this.fileInput.current.files[0].type
                };
                this.setState({ temporaryImage: e.target.result });
                callbackFn(payload);
            };
            reader.readAsDataURL(this.fileInput.current.files[0]);
        }
    }

    render() {
        const { children, t } = this.props;
        const { height, showUpload, temporaryImage, width } = this.state;
        return (
            <div onMouseEnter={() => this.setState({ showUpload: true })}>
                {!showUpload && (
                    <Button
                        data-trackid="fileUpload_showUpload"
                        variant="outlined"
                        component="label"
                        style={{
                            cursor: 'pointer',
                            height,
                            width
                        }}
                    >
                        <div>{children}</div>
                    </Button>
                )}
                {showUpload && (
                    <Button
                        data-trackid="fileUpload_uploadFile"
                        variant="outlined"
                        component="label"
                        style={{
                            cursor: 'pointer',
                            height,
                            width
                        }}
                    >
                        <input
                            ref={this.fileInput}
                            type="file"
                            accept="image/*"
                            onChange={() => {
                                this.handleChange();
                            }}
                            style={{ display: 'none' }}
                        />
                        {temporaryImage === null ? (
                            <div
                                style={{
                                    height,
                                    opacity: 0.2,
                                    width
                                }}
                            >
                                {children}
                            </div>
                        ) : (
                            <img
                                alt={t('FileUpload.uploadAFile')}
                                style={{
                                    height,
                                    width
                                }}
                                src={temporaryImage}
                            />
                        )}
                        <Publish
                            sx={{
                                color: 'button.primary',
                                position: 'absolute'
                            }}
                        />
                    </Button>
                )}
            </div>
        );
    }
}
export default withTranslation()(FileUpload);
